import { render } from "./ShowtimeQuickSelectorEditor.vue?vue&type=template&id=6470af88"
import script from "./ShowtimeQuickSelectorEditor.vue?vue&type=script&lang=js"
export * from "./ShowtimeQuickSelectorEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCheckbox,QSelect});
